import { horizontalCommonStyles } from './horizontalCommon';
export const horizontalIconCommonStyles = (FOUNDATIONS, FONT) => ({
    ...horizontalCommonStyles(FOUNDATIONS, FONT),
    container: {
        ...horizontalCommonStyles(FOUNDATIONS, FONT).container,
        padding: FOUNDATIONS.spacing_250,
    },
    contentContainer: {
        ...horizontalCommonStyles(FOUNDATIONS, FONT).contentContainer,
        padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250}`,
    },
});
//# sourceMappingURL=horizontalIconCommon.js.map